// NTD: preview-only helper: marks "[REVIEW: …]" notes so reviewers can spot owner decisions. Remove before launch.
(function () {
  function mark() {
    document.querySelectorAll('em, strong, p, li, span').forEach(function (el) {
      if (el.children.length === 0 && /^\s*\[REVIEW/.test(el.textContent)) el.classList.add('ntd-review');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  document.addEventListener('shopify:section:load', mark);
})();

// NTD: keep the first FAQ row open on desktop only; collapse it on phones.
(function () {
  function faq() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.collapsible-content details[open]').forEach(function (d) { d.removeAttribute('open'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', faq); else faq();
})();
